var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageHeader',{attrs:{"title":_vm.$t('trees'),"icon":"mdi-pine-tree"}},[_vm._v(" WIP ")])}
var staticRenderFns = []

export { render, staticRenderFns }